import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = { class: "flex flex-row items-center mt-8" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  class: "w-6 h-6 mr-4"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L6.832 19.82a4.5 4.5 0 01-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 011.13-1.897L16.863 4.487zm0 0L19.5 7.125"
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Edit board styles", -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { class: "flex flex-col" }
const _hoisted_7 = { class: "flex flex-row mt-8" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 w-40" }, "Description", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "h-px w-full bg-gray-300 my-4" }, null, -1)
const _hoisted_10 = { class: "flex flex-row" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 w-40" }, "Domain Name", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "h-px w-full bg-gray-300 my-4" }, null, -1)
const _hoisted_13 = { class: "flex flex-row items-center" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 w-40" }, "Primary Color", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "h-px w-full bg-gray-300 my-4" }, null, -1)
const _hoisted_16 = { class: "flex flex-row items-center" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 w-40" }, "Secondary Color", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "h-px w-full bg-gray-300 my-4" }, null, -1)
const _hoisted_19 = { class: "flex flex-row items-center" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 w-40" }, "Published Jobs", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "h-px w-full bg-gray-300 my-4" }, null, -1)
const _hoisted_22 = { class: "flex flex-row items-center" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 w-40" }, "Staff Name", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "h-px w-full bg-gray-300 mt-4" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomCompany = _resolveComponent("CustomCompany")!
  const _component_ReusableModal = _resolveComponent("ReusableModal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openModal = true)),
          class: "flex flex-row btn-filled-sm"
        }, _hoisted_5)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("p", null, _toDisplayString(_ctx.company.description), 1)
        ]),
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("span", null, _toDisplayString(_ctx.company.domain_name), 1)
        ]),
        _hoisted_12,
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          (_ctx.company.secondary_color)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "w-4 h-4 mr-2",
                style: _normalizeStyle(`background-color: ${_ctx.company.primary_color}`)
              }, null, 4))
            : _createCommentVNode("", true),
          _createElementVNode("span", null, _toDisplayString(_ctx.company.primary_color), 1)
        ]),
        _hoisted_15,
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          (_ctx.company.secondary_color)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "w-4 h-4 mr-2",
                style: _normalizeStyle(`background-color: ${_ctx.company.secondary_color}`)
              }, null, 4))
            : _createCommentVNode("", true),
          _createElementVNode("span", null, _toDisplayString(_ctx.company.secondary_color), 1)
        ]),
        _hoisted_18,
        _createElementVNode("div", _hoisted_19, [
          _hoisted_20,
          _createElementVNode("span", null, _toDisplayString(_ctx.company.published_jobs), 1)
        ]),
        _hoisted_21,
        _createElementVNode("div", _hoisted_22, [
          _hoisted_23,
          _createElementVNode("span", null, _toDisplayString(_ctx.company.staff_name), 1)
        ]),
        _hoisted_24
      ])
    ]),
    _createVNode(_component_ReusableModal, {
      show: _ctx.openModal,
      onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openModal = false)),
      size: "w-1/2"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_CustomCompany, {
          onCloseModal: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openModal = false)),
          onUpdateBranding: _ctx.updateBranding,
          company: _ctx.company,
          companyId: _ctx.companyId
        }, null, 8, ["onUpdateBranding", "company", "companyId"])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}